export default {"src":"/_next/static/media/female.0a9b4501.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};